// Mapping of locale codes to language names
export const LOCALE_NAMES = {
  'ar': 'العربية',
  'bn': 'বাংলা',
  'cs': 'Čeština',
  'da': 'Dansk',
  'de': 'Deutsch',
  'en': 'English',
  'es': 'Español',
  'fi': 'Suomi',
  'fr': 'Français',
  'he': 'עברית',
  'hi': 'हिन्दी',
  'id': 'Bahasa Indonesia',
  'it': 'Italiano',
  'ja': '日本語',
  'ko': '한국어',
  'ms': 'Bahasa Melayu',
  'nb': 'Norsk Bokmål',
  'nl': 'Nederlands',
  'pl': 'Polski',
  'pt-BR': 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  'fa': 'فارسی',
  'ru': 'Русский',
  'sv': 'Svenska',
  'th': 'ไทย',
  'tr': 'Türkçe',
  'uk': 'Українська',
  'vi': 'Tiếng Việt',
  'zh-CN': '中文 (简体)',
  'zh-TW': '中文 (繁體)'
};

// Helper function to get language name from locale code
export const getLanguageName = (localeCode) => {
  return LOCALE_NAMES[localeCode] || localeCode.toUpperCase();
};

// Helper function to get all available locales with names
export const getLocaleOptions = (localeCodes) => {
  return localeCodes.map(localeCode => ({
    label: getLanguageName(localeCode),
    value: localeCode
  }));
}; 